import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Button2 from "@mui/material/Button";
import React from 'react';
import { SendIcon } from './icons';

// Generic "illustration + title + description + CTA" banner — light blue card used for the
// various "this feature starts once the event begins" empty states (stats tab, leaderboard tab,
// ...), so they all share one look (and one CTA icon) instead of each reimplementing it slightly
// differently.
export function IllustratedCtaCard({
  Button: _Button,
  bgcolor = '#D9E7FF',
  ctaBgcolor,
  ctaLabel,
  description,
  icon,
  illustration,
  onCtaClick,
  title
}) {
  const Button = _Button || _Button2;
  const startIcon = icon === undefined ? /*#__PURE__*/React.createElement(SendIcon, {
    fontSize: "small"
  }) : icon ?? undefined;
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: bgcolor,
    borderRadius: 4,
    display: "flex",
    flexWrap: "wrap",
    gap: 5,
    padding: 4
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: illustration,
    width: 220
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 4,
    minWidth: 280
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    color: "#2C2E30",
    fontSize: 18,
    fontWeight: 700,
    lineHeight: "32px"
  }, title), /*#__PURE__*/React.createElement(_Typography, {
    color: "text.secondary",
    component: "div"
  }, description)), /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: onCtaClick,
    size: "medium",
    startIcon: startIcon,
    sx: {
      borderRadius: 2,
      textTransform: 'initial',
      ...(ctaBgcolor && {
        bgcolor: ctaBgcolor,
        '&:hover': {
          bgcolor: ctaBgcolor
        }
      })
    },
    variant: "contained"
  }, ctaLabel))));
}